var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-background max-h-screen min-h-screen bg-white flex overflow-hidden"
  }, [_c('div', {
    staticClass: "flex-1 flex flex-col justify-center z-10 w-full py-1/2 px-4 sm:px-6 md:max-w-96 md:py-1/4 md:justify-start lg:justify-center lg:max-w-lg lg:py-12 lg:flex-none lg:pl-20 xl:ml-24 2xl:pl-14 2xl:ml-32"
  }, [_c('div', {}, [_c('a', {
    staticClass: "flex items-center",
    attrs: {
      "href": "https://neopass.fr"
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600 w-max-content w-max",
    attrs: {
      "name": "logo-neopass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_c('input-text', {
    staticClass: "w-full mt-1",
    attrs: {
      "id": "username",
      "name": "username",
      "libelle": "",
      "value": _vm.form.username,
      "big": true,
      "placeholder": "Adresse email ou identifiant",
      "voiceInput": false
    },
    on: {
      "input": function (newValue) {
        _vm.form.username = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-6"
  }, [_c('input-text', {
    staticClass: "w-full mt-1",
    attrs: {
      "name": "password",
      "libelle": "",
      "type": "password",
      "value": _vm.form.password,
      "big": true,
      "placeholder": "Mot de passe"
    },
    on: {
      "input": function (newValue) {
        _vm.form.password = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 flex justify-end"
  }, [_c('div', {
    staticClass: "text-sm leading-5"
  }, [_c('router-link', {
    staticClass: "text-indigo-600 hover:text-indigo-400 focus:outline-none focus:underline transition ease-in-out duration-150",
    attrs: {
      "to": {
        name: 'ForgotPassword'
      }
    }
  }, [_vm._v("\n                Mot de passe oublié\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 space-y-4 flex flex-col items-center justify-between sm:space-y-0 sm:flex-row"
  }, [_c('big-action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CONNEXION",
      "spinner": _vm.loading,
      "right": true,
      "icon": "arrow-right_1",
      "type-shadow": "shadow-pink"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_c('big-action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-white",
      "bg-color-square": "bg-white",
      "icon-color": "text-pink-600",
      "libelle": "INSCRIPTION",
      "right": true,
      "icon": "plus-circle"
    }
  })], 1)], 1), _vm._v(" "), _c('v-errors', {
    staticClass: "mt-6 text-sm text-center text-red-500",
    attrs: {
      "errors": Object.assign({}, _vm.errors)
    }
  })], 1)])])]), _vm._v(" "), _c('help-button', {
    staticClass: "z-10",
    on: {
      "helpClick": function ($event) {
        _vm.showHelp = true;
      }
    }
  }), _vm._v(" "), _c('help', {
    attrs: {
      "show-help": _vm.showHelp
    },
    on: {
      "close": function ($event) {
        _vm.showHelp = false;
      }
    }
  }), _vm._v(" "), _c('session-expire-popup', {
    attrs: {
      "is-show": _vm.isSessionExpired
    },
    on: {
      "close": function ($event) {
        _vm.isSessionExpired = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }